module.exports = " <section> <h3 class=title>{{ title }}</h3> <h3 class=subtitle>{{ subtitle }}</h3> <div class=\"columns is-gapless is-multiline is-mobile\"> <div class=code v-for=\"code in codes\" @click=Play(Encode(code))> <p class=heading>{{Encode(code)}}</p> <p class=title>{{code}}</p> </div> </div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeTable.vue
 ** module id = 158
 ** module chunks = 2
 **/